<div class="p-20">
  <div class="" fxLayout="column" fxLayoutAlign="start center"  fxFlex="100">
<mat-card class="example-card mat-elevation-z4 mb-20 card">
  <mat-card-header>
    <mat-card-title>
      <div fxLayout="row" fxLayoutAlign="start center">
        {{'EMAI_LOG.TABLA_GLOBAL.TITU' | translate}}
        <button mat-mini-fab color="primary" (click)="actualizarHistorial()" style="margin-left:10px" matTooltip="{{'HISTORIAL_MAILS.ACCIONES.LISTA.getEnviados' | translate}}">
          <mat-icon>autorenew</mat-icon>
        </button>
      </div>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <!-- <h2>{{'EMAI_LOG.TABLA_GLOBAL.SUB_TIT' | translate}} 10</h2> -->
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width:100%">

        <ng-container matColumnDef="objeto">
          <th mat-header-cell *matHeaderCellDef class="lftBrd"> {{'EMAI_LOG.TABLA_GLOBAL.TH_1' | translate}}</th>
          <td mat-cell  class="lftBrd alingCont" *matCellDef="let element"><span class="span"class="material-icons-outlined">{{element.icon}}</span>{{'EMAI_LOG.TABLA_GLOBAL.'+element.status | translate}}</td>
        </ng-container>

        <ng-container matColumnDef="aviso1">
          <th mat-header-cell *matHeaderCellDef class="lftBrd"> {{'EMAI_LOG.TABLA_GLOBAL.TH_2' | translate}}</th>
          <td mat-cell  class="lftBrd alingCont" *matCellDef="let element;let a = index;">
            <div fxLayout="row" fxLayoutAlign="center center" >
              <button mat-stroked-button color="primary" aria-label="Example icon button with a vertical three dot icon"  (click)="tipoCorreosMostrar(element,'aviso1')" matTooltip="{{'EMAI_LOG.TABLA_GLOBAL.VIE_DETA_TOOL' | translate}}">
                {{element.aviso1}}
              </button>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="aviso2">
          <th mat-header-cell *matHeaderCellDef class="lftBrd"> {{'EMAI_LOG.TABLA_GLOBAL.TH_3' | translate}}</th>
          <td mat-cell  class="lftBrd alingCont" *matCellDef="let element;let e = index;" >
            <div fxLayout="row" fxLayoutAlign="center center" >
              <button mat-stroked-button color="primary" aria-label="Example icon button with a vertical three dot icon" (click)="tipoCorreosMostrar(element,'aviso2')" matTooltip="{{'EMAI_LOG.TABLA_GLOBAL.VIE_DETA_TOOL' | translate}}">
                {{element.aviso2}}
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="invitacion">
          <th mat-header-cell *matHeaderCellDef class="lftBrd"> {{'EMAI_LOG.TABLA_GLOBAL.TH_4' | translate}}</th>
          <td mat-cell  class="lftBrd alingCont" *matCellDef="let element;let i = index;">
            <div fxLayout="row" fxLayoutAlign="center center" >
              <button mat-stroked-button color="primary" aria-label="Example icon button with a vertical three dot icon" (click)="tipoCorreosMostrar(element,'invitacion')"  matTooltip="{{'EMAI_LOG.TABLA_GLOBAL.VIE_DETA_TOOL' | translate}}">
                {{element.invitacion}}
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="recor1">
          <th mat-header-cell *matHeaderCellDef class="lftBrd"> {{'EMAI_LOG.TABLA_GLOBAL.TH_5' | translate}}</th>
          <td mat-cell  class="lftBrd alingCont" *matCellDef="let element;let o = index;">
            <div fxLayout="row" fxLayoutAlign="center center" >
              <button mat-stroked-button color="primary" aria-label="Example icon button with a vertical three dot icon"  (click)="tipoCorreosMostrar(element,'recor1')" matTooltip="{{'EMAI_LOG.TABLA_GLOBAL.VIE_DETA_TOOL' | translate}}">
                {{element.recor1}}
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="recor2">
          <th mat-header-cell *matHeaderCellDef class="lftBrd">{{'EMAI_LOG.TABLA_GLOBAL.TH_6' | translate}}</th>
          <td mat-cell  class="lftBrd alingCont" *matCellDef="let element;let u = index;">
            <div fxLayout="row" fxLayoutAlign="center center" >
              <button mat-stroked-button color="primary" aria-label="Example icon button with a vertical three dot icon" (click)="tipoCorreosMostrar(element,'recor2')" matTooltip="{{'EMAI_LOG.TABLA_GLOBAL.VIE_DETA_TOOL' | translate}}">
                {{element.recor2}}
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

  </mat-card-content>
</mat-card>
<ng-container *ngIf="cargando==1">
  <div fxLayout="column" fxLayoutAlign="space-between center" >
    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
    <h1>{{'EMAI_LOG.TEX_MOD_CHA_INFO' | translate}}</h1>
  </div>
</ng-container>
<ng-container *ngIf="cargando==2">
  <mat-card class="example-card mat-elevation-z4 mb-20 card">
    <mat-card-header>
      <mat-card-title>{{tituloCabezeraEmails}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="" fxLayout="column" fxLayoutAlign="start stretch">
        <div class="" style="margin-top:20px;margin-left:20px" fxLayout="row" fxLayoutAlign="space-between center">
          <mat-form-field appearance="outline" fxFlex="60" >
            <mat-label>{{'EMAI_LOG.TABLA_COLAB.TEX_SEARC_COLAB' | translate}}</mat-label>
            <input matInput  (keyup)="applyFilter($event.target.value)">
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
            <button mat-raised-button color="primary" (click)="exportTable();" *ngIf="statusCorreoBuscar=='notDelivered'">{{'CONSULTARENCUESTA.BOTON_DESCARGA_EXCEL' | translate }}</button>
        </div>


        <!-- <h2>{{'EMAI_LOG.TABLA_COLAB.SUB_TIT' | translate}} 20</h2> -->
        <table mat-table [dataSource]="datosTablaTipoCorreo" class="mat-elevation-z8" style="width:100%" matSort>

          <ng-container matColumnDef="Event">
            <th mat-header-cell *matHeaderCellDef class="lftBrd"> {{'EMAI_LOG.TABLA_COLAB.TH_1' | translate}}</th>
            <td mat-cell  class="lftBrd" *matCellDef="let element">
              <div class="" fxLayout="row" fxLayoutAlign="center center" >
                <span class="material-icons-outlined" style="color:{{colorIconStatus}};" *ngIf="element.Event =='delivered'">verified</span>
                <span class="material-icons-outlined" style="color:{{colorIconStatus}};" *ngIf="element.Event =='processed'">pending</span>
                <span class="material-icons-outlined" style="color:{{colorIconStatus}};"  *ngIf="element.Event =='bounce'||element.Event =='dropped'">dangerous</span>
              <p style="margin-right:10px">{{'EMAI_LOG.TABLA_COLAB.'+element.Event | translate}}</p>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="UserName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header  class="lftBrd"> {{'EMAI_LOG.TABLA_COLAB.TH_2' | translate}}</th>
            <td mat-cell  class="lftBrd" *matCellDef="let element">
              <div class="" fxLayout="matRowDef" fxLayoutAlign="center center" >
               {{element.UserName}}
             </div>
             </td>
          </ng-container>

          <ng-container matColumnDef="EMail">
            <th mat-header-cell *matHeaderCellDef  class="lftBrd" mat-sort-header> {{'EMAI_LOG.TABLA_COLAB.TH_3' | translate}}</th>
            <td mat-cell  class="lftBrd" *matCellDef="let element">
              <div class="" fxLayout="column" fxLayoutAlign="center center" >
                <p> {{element.EMail}} </p>
              </div>
            </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="SendDateTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header  class="lftBrd"> {{'EMAI_LOG.TABLA_COLAB.TH_4' | translate}}</th>
            <td mat-cell  class="lftBrd" *matCellDef="let element">
              <div class="" fxLayout="row" fxLayoutAlign="center center" >
                {{element.SendDateTime|date:'d MMM y H:mm':offsetPipe:idiomaActual}}{{element.SendDateTime|date:'z':offsetPipe:idiomaActual}}
             </div>
            </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="TotalEnvios">
            <th mat-header-cell *matHeaderCellDef mat-sort-header  class="lftBrd"> {{'EMAI_LOG.TABLA_COLAB.TH_5' | translate}}</th>
            <td mat-cell  class="lftBrd" *matCellDef="let element">
              <div class="" fxLayout="row" fxLayoutAlign="center center" >
                <span matBadge="{{element.Total}}" matBadgeColor="accent" ></span>
             </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="accion">
            <th mat-header-cell *matHeaderCellDef class="lftBrd"> {{'EMAI_LOG.TABLA_COLAB.TH_6' | translate}}</th>
            <td mat-cell  class="lftBrd" *matCellDef="let element">
              <div class="" fxLayout="row" fxLayoutAlign="center center" >
                <button mat-icon-button aria-label="Example icon button with a vertical three dot icon"  (click)="verConfigResult(element);">
                  <span class="material-icons-outlined">preview</span>
                </button>
             </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns3"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns3;"></tr>
        </table>
        <mat-paginator class="tamaño" style-paginator  [pageSize]="20" showFirstLastButtons [showTotalPages]="3" [pageSizeOptions]="[50, 100, 500, 1000]" [length]="datosTablaTipoCorreo.data.length"></mat-paginator>
      </div>

    </mat-card-content>
  </mat-card>

</ng-container>


</div>
</div>
